<template>
  <svg :width="size" :height="size" viewBox="0 0 100 100" class="coin" :class="{ 'coin-gray': gray }" aria-hidden="true">
    <defs>
      <linearGradient :id="ga" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stop-color="#FFF1B8" /><stop offset=".45" stop-color="#F7C21A" /><stop offset="1" stop-color="#D38F00" />
      </linearGradient>
      <linearGradient :id="gb" x1="1" y1="1" x2="0" y2="0">
        <stop offset="0" stop-color="#FFE27A" /><stop offset=".55" stop-color="#E9A500" /><stop offset="1" stop-color="#C98300" />
      </linearGradient>
    </defs>
    <circle cx="50" cy="53" r="46" fill="#9C6600" />
    <circle cx="50" cy="49" r="46" :fill="`url(#${ga})`" />
    <circle cx="50" cy="49" r="37" :fill="`url(#${gb})`" stroke="#FFF1B8" stroke-opacity=".7" stroke-width="1.6" />
    <g transform="translate(17.2 16.6) scale(.104)">
      <path :d="LOGO" fill="#FFF4CC" fill-rule="evenodd" transform="translate(-10 -10)" opacity=".75" />
      <path :d="LOGO" fill="#9A6200" fill-rule="evenodd" />
    </g>
    <ellipse cx="34" cy="26" rx="16" ry="7" fill="#fff" opacity=".35" transform="rotate(-30 34 26)" />
  </svg>
</template>

<script>
// Счётчик на уровне модуля — у каждой монеты свои id градиентов
let uid = 0;
</script>

<script setup>
defineProps({
  size: { type: Number, default: 24 },
  gray: { type: Boolean, default: false }
});
const n = ++uid;
const ga = `coinGA${n}`;
const gb = `coinGB${n}`;
const LOGO = 'M68 175H395L237 460L148 305H192L232 372L318 220H95Z M108 248H170L185 275H123Z M408 178L567 463H252Z M406 272L318 420H491Z';
</script>

<style scoped>
.coin { display: block; overflow: visible; flex-shrink: 0; }
.coin-gray { filter: grayscale(1) brightness(1.25) contrast(.95); }
</style>
